module.exports = __webpack_public_path__ + "img/10.c7ce0544.png";